import React, { useState } from 'react';
import '../../styles/quiz-base.css';
import './pesoDesejado.css';
import Footer from '../../components/footer/Footer';

const API_BASE = process.env.REACT_APP_API_BASE;

const PesoDesejado = ({ onSucesso }) => {
  const [peso, setPeso] = useState('');
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [mostrarEditarPeso, setMostrarEditarPeso] = useState(false);

  const handleChange = (e) => {
    setPeso(e.target.value);
    setErro('');
    setMostrarEditarPeso(false);
  };

  const handleEditarPesoAtual = async () => {
    try {
      await fetch(`${API_BASE}/quizpeso.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          acao: 'reset_peso_atual'
        })
      });

      // Recarrega a página — o quiz volta automaticamente
      window.location.reload();
    } catch (error) {
      setErro('Erro ao tentar editar o peso atual.');
    }
  };

  const handleEnviar = async () => {
    const pesoNum = parseFloat(peso.replace(',', '.'));

    if (isNaN(pesoNum) || pesoNum < 30 || pesoNum > 500) {
      setErro('Digite um peso válido.');
      return;
    }

    setEnviando(true);
    setErro('');
    setMostrarEditarPeso(false);

    try {
      const resposta = await fetch(`${API_BASE}/quizpeso.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          peso_desejado: pesoNum
        })
      });

      const dados = await resposta.json();

      if (dados.status === 'sucesso') {
        onSucesso();
        return;
      }

      // Tratamento específico por código
      if (dados.codigo === 'peso_desejado_invalido') {
        setErro('O peso desejado deve ser menor que o peso atual.');
        setMostrarEditarPeso(true);
      } else if (dados.codigo === 'peso_atual_nao_definido') {
        setErro('Precisamos confirmar seu peso atual antes.');
        setMostrarEditarPeso(true);
      } else {
        setErro(dados.mensagem || 'Erro ao salvar. Tente novamente.');
      }

    } catch (error) {
      setErro('Erro ao conectar com o servidor.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="quiz-etapa">
      <img src="/assets/logo1.png" alt="Logo NutriFitMe" className="quiz-logo" />

      <div className="quiz-progresso">
        <div className="quiz-progresso-barra">
          <div className="quiz-progresso-preenchido" style={{ width: '100%' }}></div>
        </div>
        <div className="quiz-progresso-texto">7 de 7</div>
      </div>

      <h2 className="quiz-pergunta">Qual é o seu peso desejado?</h2>
      <p className="quiz-texto-extra">
        Informe sua meta de peso para ajustarmos seus cálculos.
      </p>

      <input
        type="number"
        className="quiz-input"
        placeholder="Ex: 70"
        value={peso}
        onChange={handleChange}
        min="30"
        max="500"
      />

      {erro && <p className="quiz-erro">{erro}</p>}

      {mostrarEditarPeso && (
        <button
          type="button"
          className="quiz-botao-secundario"
          onClick={handleEditarPesoAtual}
        >
          Editar peso atual
        </button>
      )}

      <button
        className={`quiz-botao ${peso && !enviando ? 'ativo' : ''}`}
        onClick={handleEnviar}
        disabled={!peso || enviando}
      >
        {enviando ? 'Enviando...' : 'Continuar'}
      </button>

      <div className="quiz-footer">
        <Footer />
      </div>
    </div>
  );
};

export default PesoDesejado;
